export const OPEN_PHONE_NUMBER_MODAL = 'OPEN_PHONE_NUMBER_MODAL';
export const CLOSE_PHONE_NUMBER_MODAL = 'CLOSE_PHONE_NUMBER_MODAL';
